export default class ChannelsAddController {
    constructor($scope, $routeParams, $location, channelsService, notificationsService, authenticationService, globalConstants) {
        this.$location = $location;
        this.$scope = $scope;
        this.channelsService = channelsService;
        this.notificationsService = notificationsService;
        this.authenticationService = authenticationService;
        this.globalConstants = globalConstants;
        this.channel = {};
        this.channel.avatars = [];
        this.avatar = {
            icon: 'default1.png',
            image: undefined
        };        
    }

    addNewAvatar(){
        this.showAddForm = true;
    }

    removeAvatar(avatar){
        var index = this.channel.avatars.indexOf(avatar);
        this.channel.avatars.splice(index, 1);           
    }

    addAvatar() {
        if(this.avatar === undefined || this.avatar.name == "" || this.avatar.name == null) {
            this.notificationsService.show("Please enter an avatar name", "error");
            return;
        }
        //copy list
        var avatar = JSON.parse(JSON.stringify(this.avatar));
        var that = this;
        that.btnDisabled = true;
        
        this.readFile().then(function (data){
            if(data.image == "" || data.image == null) {
                
                //avatar.image = that.avatar.icon;
                avatar.icon = that.avatar.icon;
                avatar.imagetype = "image/png";
            }
            else{
                avatar.icon = undefined;
                avatar.image = data.image;
                avatar.imagetype = data.mimetype;
            }
            that.$scope.ctrl.channel.avatars.push(avatar);
            that.avatar = undefined;
            document.getElementById('file').value = "";
            that.$scope.ctrl.btnDisabled = false;
            that.$scope.ctrl.showAddForm = false;
            that.$scope.$apply();
        })
    }

    readFile() {
        return new Promise(function(resolve, reject) {
            var f = document.getElementById('file').files[0],
            r = new FileReader(),
            data = [];

            if(!f){
                resolve(data);
            }
        
            var mimetype = f.type;

            r.onloadend = function(e) {
                var image = btoa(new Uint8Array(e.target.result).reduce(function (data, byte){
                    return data + String.fromCharCode(byte);
                }, ''));

                data.image = image;
                data.mimetype = mimetype;
                data.fileextension = f.name.split('.').pop();

                resolve(data);
            }
            r.readAsArrayBuffer(f);
        });
    };

    onSave() { 
        var that = this;
        this.channelsService.add(this.channel).then(resp => {
            if(this.authenticationService.isSuperUser()) {
                that.$location.path('/subscriptions')
            }
            that.notificationsService.show("Channel added", "success");
        }, resp =>{
            that.notificationsService.show("Error saving channel")
        });
    }

    goBack(){
        var that = this;
        if(this.authenticationService.isSuperUser()) {
            that.$location.path('/subscriptions')
        }
        else
        {
            that.$location.path('/manage')
        }
    }

    clearImageUpload() {
        document.getElementById('file').value = null;
        this.imageData = undefined;
    }
}


// WEBPACK FOOTER //
// ./src/js/components/channels/channels.add.controller.js